import { C } from '../../theme.js';
import { Eyebrow, FieldLabel } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { MultiCols } from '../shared/MultiCols.jsx';

export function TrimInspector({ step, onChange }) {
  const c = step.config || {};
  const sel = c.columns || [];
  return (
    <div>
      <Eyebrow>Trim columns</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Strips leading & trailing whitespace from the chosen string columns.
        With no columns selected, every string column is trimmed.
      </div>
      <MultiCols selected={sel} onChange={(v) => onChange({ ...step, config: { ...c, columns: v } })} />
      <FieldLabel>Also collapse</FieldLabel>
      <Segmented
        value={c.internal || 'no'}
        onChange={(v) => onChange({ ...step, config: { ...c, internal: v } })}
        options={[
          { value: 'no', label: 'Edges only' },
          { value: 'yes', label: 'Collapse repeated spaces' },
        ]}
      />
    </div>
  );
}
